export default __webpack_public_path__ + "static/media/three.6d1f0c95.jpg";